// src/contexts/UserContext.tsx

import React, { createContext, useState, useEffect, ReactNode } from 'react';
import { UserDTO } from '../pages/profileSetting/UserDTO';
import { instance } from '../api/axiosInstance'; // 이미 정의된 Axios 인스턴스
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

interface UserContextType {
    user: UserDTO | null;
    setUser: React.Dispatch<React.SetStateAction<UserDTO | null>>;
}

export const UserContext = createContext<UserContextType>({
    user: null,
    setUser: () => {},
});

interface UserProviderProps {
    children: ReactNode;
}

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
    const [user, setUser] = useState<UserDTO | null>(() => {
        const storedUser = localStorage.getItem('user');
        return storedUser ? JSON.parse(storedUser) : null;
    });
    const [loading, setLoading] = useState<boolean>(true); // 로딩 상태
    const navigate = useNavigate(); // Initialize navigate

    useEffect(() => {
        // 서버에서 사용자 데이터를 가져오는 함수
        const fetchUser = async () => {
            try {
                // 'access_token' 쿠키 가져오기
                const accessToken = Cookies.get('access_token');
                console.log("access_token:", accessToken);

                if (!accessToken) {
                    throw new Error('인증 토큰이 없습니다.');
                }

                // Axios 요청에 Authorization 헤더 추가 (인터셉터 설정으로 대체 가능)
                const response = await instance.get('/auth/users/me', {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.status === 200) {
                    const userData: UserDTO = response.data;
                    console.log("사용자 데이터:", userData);
                    setUser(userData);
                    localStorage.setItem('user', JSON.stringify(userData)); // 사용자 데이터를 localStorage에 저장
                }
            } catch (error: any) {
                console.error('사용자 정보를 가져오는데 실패했습니다:', error);

                // 특정 오류 처리
                if (error.response && error.response.status === 403) {
                    setUser(null);
                    localStorage.removeItem('user');
                    Cookies.remove('access_token'); // 'access_token' 쿠키 제거
                    navigate('/login'); // Redirect to login page on 401
                }

                toast.error('다시 로그인을 해주시길 바랍니다.');
            } finally {
                setLoading(false);
            }
        };

        // 'access_token'이 존재하는지 확인
        const accessToken = Cookies.get('access_token');
        if (accessToken) {
            fetchUser();
        } else {
            console.log("인증 토큰 없음.");
            setLoading(false); // 토큰이 없으면 로딩 중지
        }
    }, [navigate]); // Add navigate to dependencies

    return (
      <UserContext.Provider value={{ user, setUser }}>
          {!loading ? (
            children
          ) : (
            <div className="flex items-center justify-center h-screen">
                <p>로딩 중...</p>
            </div>
          )}
      </UserContext.Provider>
    );
};
